import React from 'react';
import { GovEmpty, GovFlex, GovIcon } from '@gov-design-system-ce/react';
import { SideBoxHeader } from '@gov-nx/component/web';
import { useNotificationMessageLoader } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { ContentLayout } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

export const DashboardUnreadNotificationsWidgetView = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(LocalizeNameSpaceTypes.Global);

	const { unreadNotifications } = useNotificationMessageLoader();

	return (
		<ContentLayout customClasses="p-0!">
			<SideBoxHeader link={PageCode['upozorneni']}>
				<GovIcon
					name="bell-fill"
					type="templates"
					slot="icon"
				/>
				{ts('upozorneni.neprectena')}
			</SideBoxHeader>

			{!unreadNotifications.length ? (
				<GovEmpty
					icon={
						<GovIcon
							name="communication"
							type="complex"
							slot="icon"
						/>
					}
					headline={<p slot="headline">{ts('box-neprectene.nic-neuniklo')}</p>}
					size="s"
					align="center">
					<p>{ts('box-neprectene.vsechny-prectene')}</p>
				</GovEmpty>
			) : (
				<ul className="gov-list--plain mt-0! pb-(--templates-margin-m)">
					{unreadNotifications.slice(0, 3).map((notification) => (
						<li
							className="border-b border-(--border-subtlest) [ last-of-type:border-b-0 ]"
							key={notification?.id}>
							<a
								href={PageCode['upozorneni']}
								className="anim-bg-hover flex gap-(--spacing-s-nudge) py-(--spacing-m) px-(--spacing-m-nudge) no-underline!">
								<GovIcon
									name="notification"
									type="templates"
									slot="icon"
									className="relative top-[5px] w-3! h-3! text-(--button-solid-secondary)!"
								/>
								<GovFlex
									gap="xs"
									className="w-full">
									<div className="text-body-m-bold text-(--text-primary-color)">
										{notification.nazev}
									</div>
									<span className="relative top-[3px] text-body-xs text-(--text-secondary)">
										{notification.datumACasVytvoreni
											? toDateReadable(notification.datumACasVytvoreni)
											: undefined}
									</span>
								</GovFlex>
							</a>
						</li>
					))}
				</ul>
			)}
		</ContentLayout>
	);
};
